<template>
  <v-container fluid  py-0 px-0>
    <u-i-toolbar-admin title="Not arrived orders" icon="as fa-file-alt" />
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';

export default {
  name: 'NotArrivedOrders',
  metaInfo: {
    titleTemplate: '%s - Admin | Not arrived orders',
  },
  components: {
    UIToolbarAdmin,
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {

  }
}
</script>